import get from 'lodash/get';
import { createSelector } from 'reselect';

import { TEMPERATURE_METRIC } from '../../../constants';

export const selectPatientPortalRootState = state =>
  get(state, 'profiles.patientHealthboard');

export const selectVitalsActivityEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'vitalsActivity.list', []),
);

export const selectHistoricMeasurementsList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'historicMeasurements.list', []),
);

export const selectHistoricMeasurementsListPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'historicMeasurements.sending', false),
);

export const selectHistoricMeasurementsPreviousDate = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'historicMeasurements.meta.previousPeriodStartDate', ''),
);

export const selectStepsMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'stepsMeasurement.list', []),
);

export const selectSaturationMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'saturationMeasurement.list', []),
);

export const selectSaturationMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'saturationMeasurementModal.list', []),
);

export const selectHeartRateMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heartRateMeasurement.list', []),
);

export const selectHeartRateMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heartRateMeasurementModal.list', []),
);

export const selectBMIMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bmiMeasurementModal.list', []),
);

export const selectBloodGlucoseMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodGlucoseMeasurementModal.list', []),
);

export const selectStepsMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'stepsMeasurementModal.list', []),
);

export const selectDistanceMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'distanceMeasurementModal.list', []),
);

export const selectWeightMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'weightMeasurementModal.list', []),
);

export const selectHeightMeasurementModalHistoricList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heightMeasurementModal.list', []),
);

export const selectStepsMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'stepsMeasurementModal.list', []),
);

export const selectStepsMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'stepsMeasurement.sending', false),
);

export const selectSaturationMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'saturationMeasurement.sending', false),
);

export const selectHeartRateMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heartRateMeasurement.sending', false),
);

export const selectStepsMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'stepsMeasurementModal.sending', false),
);

export const selectSaturationMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'saturationMeasurementModal.sending', false),
);

export const selectHeartRateMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heartRateMeasurementModal.sending', false),
);

export const selectDistanceMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'distanceMeasurement.list', []),
);

export const selectDistanceMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'distanceMeasurementModal.list', []),
);

export const selectDistanceMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'distanceMeasurement.sending', false),
);

export const selectDistanceMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'distanceMeasurementModal.sending', false),
);

export const selectBMIMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bmiMeasurement.list', []),
);

export const selectBMIMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bmiMeasurementModal.list', []),
);

export const selectBMIMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bmiMeasurement.sending', false),
);

export const selectBMIMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bmiMeasurementModal.sending', false),
);

export const selectBloodGlucoseMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodGlucoseMeasurement.list', []),
);

export const selectBloodGlucoseMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodGlucoseMeasurementModal.list', []),
);

export const selectBloodGlucoseMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodGlucoseMeasurement.sending', false),
);

export const selectBloodGlucoseMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodGlucoseMeasurementModal.sending', false),
);

export const selectBloodPressureMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodPressureMeasurement.list', []),
);

export const selectBloodPressureMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodPressureMeasurement.sending', false),
);

export const selectBloodPressureMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodPressureMeasurementModal.list', []),
);

export const selectBloodPressureMeasurementModalEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bloodPressureMeasurementModal.sending', false),
);

export const selectRespiratoryRateMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'respiratoryRateMeasurement.list', []),
);

export const selectRespiratoryRateMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'respiratoryRateMeasurement.sending', false),
);

export const selectRespiratoryRateMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'respiratoryRateMeasurementModal.list', []),
);

export const selectRespiratoryRateMeasurementModalEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'respiratoryRateMeasurementModal.sending', false),
);

export const selectBodySurfaceAreaMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodySurfaceAreaMeasurement.list', []),
);

export const selectBodySurfaceAreaMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodySurfaceAreaMeasurement.sending', false),
);

export const selectBodySurfaceAreaMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodySurfaceAreaMeasurementModal.list', []),
);

export const selectBodyTemperatureMeasurementModalEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodyTemperatureMeasurementModal.sending', false),
);

export const selectBodyTemperatureMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodyTemperatureMeasurement.list', []),
);

export const selectBodyTemperatureMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodyTemperatureMeasurement.sending', false),
);

export const selectBodyTemperatureMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodyTemperatureMeasurementModal.list', []),
);

export const selectBodySurfaceAreaMeasurementModalEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'bodySurfaceAreaMeasurementModal.sending', false),
);

export const selectWeightMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'weightMeasurement.list', []),
);

export const selectWeightMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'weightMeasurementModal.list', []),
);

export const selectWeightMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'weightMeasurement.sending', false),
);

export const selectWeightMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'weightMeasurementModal.sending', false),
);

export const selectHeightMeasurementEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heightMeasurement.list', []),
);

export const selectHeightMeasurementModalEntity = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heightMeasurementModal.list', []),
);

export const selectHeightMeasurementEntityPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heightMeasurement.sending', false),
);

export const selectHeightMeasurementEntityModalPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'heightMeasurementModal.sending', false),
);

export const selectOpenedSingleDayGrafModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singleDayGrafModal.opened', false),
);

export const selectOpenedSinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.opened', false),
);

export const selectTypeSinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.type', ''),
);

export const selectEntitySinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.entity', []),
);

export const selectMonthTitleSinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.monthTitle', ''),
);

export const selectValueSinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.value', ''),
);

export const selectMetricSettingsSinglePointValuesModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singlePointValuesModal.metricSettings', {}),
);

export const selectBaseDateSingleDayGrafModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singleDayGrafModal.baseDate'),
);

export const selectTypeSingleDayGrafModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'singleDayGrafModal.type'),
);

export const selectTypeAddDataModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'addDataModal.type'),
);

export const selectOpenedAddDataModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'addDataModal.opened'),
);

export const selectOpenedGoogleFitModal = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'googleFitModal.opened'),
);

export const selectAddWeightDataPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'addWeightData.sending', false),
);

export const selectAddHeightDataPending = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'addHeightData.sending', false),
);

export const selectCurrentHealthboardOptionsDataType = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'currentHealthboardOptions.dataType'),
);

export const selectCurrentHealthboardOptionsChartPeriod = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'currentHealthboardOptions.chartPeriod'),
);

export const selectCurrentMetricWeight = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'currentHealthboardOptions.currentMetricWeight'),
);

export const selectCurrentMetricHeight = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'currentHealthboardOptions.currentMetricHeight'),
);

export const selectCurrentMetricGlucose = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'currentHealthboardOptions.currentMetricGlucose'),
);

export const selectCurrentMetricHeightType = createSelector(
  selectCurrentMetricHeight,
  state => get(state, 'type'),
);

export const selectCurrentMetricWeightType = createSelector(
  selectCurrentMetricWeight,
  state => get(state, 'type'),
);

export const selectCurrentMetricGlucoseType = createSelector(
  selectCurrentMetricGlucose,
  state => get(state, 'type'),
);

export const selectCurrentMetricTemperatureType = createSelector(
  selectPatientPortalRootState,
  state =>
    get(
      state,
      'currentHealthboardOptions.currentMetricTemperature.type',
      TEMPERATURE_METRIC.FAHRENHEIT,
    ),
);

export const selectCurrentMetrics = createSelector(
  selectCurrentMetricHeightType,
  selectCurrentMetricWeightType,
  selectCurrentMetricTemperatureType,
  selectCurrentMetricGlucoseType,
  (height, weight, temperature, glucose) => ({
    currentMetricHeight: height,
    currentMetricWeight: weight,
    currentMetricTemperature: temperature,
    currentMetricGlucose: glucose,
  }),
);

export const selectConnectedDevices = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'connectedDevices.list', []),
);

export const selectConnectedDevicesError = createSelector(
  selectPatientPortalRootState,
  state => !!get(state, 'connectedDevices.error'),
);

export const selectProviderAuthentications = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'providerAuthentications.list', []),
);

export const selectProviderList = createSelector(
  selectPatientPortalRootState,
  state => get(state, 'providerList.list', []),
);

export const combinedPendingDataRequest = createSelector(
  selectStepsMeasurementEntityPending,
  selectDistanceMeasurementEntityPending,
  selectBMIMeasurementEntityPending,
  selectBloodGlucoseMeasurementEntityPending,
  selectWeightMeasurementEntityPending,
  selectHeightMeasurementEntityPending,
  selectSaturationMeasurementEntityPending,
  selectHeartRateMeasurementEntityPending,
  (
    stepsDataPending,
    distanceDataPending,
    bmiDataPending,
    weightDataPending,
    heightDataPending,
    saturationDataPending,
    heartRateDataPending,
    bloodGlucoseDataPending,
  ) =>
    stepsDataPending ||
    distanceDataPending ||
    bmiDataPending ||
    weightDataPending ||
    heightDataPending ||
    saturationDataPending ||
    heartRateDataPending ||
    bloodGlucoseDataPending,
);

export const combinedPendingDataModalRequest = createSelector(
  selectStepsMeasurementEntityModalPending,
  selectDistanceMeasurementEntityModalPending,
  selectBMIMeasurementEntityModalPending,
  selectBloodGlucoseMeasurementEntityModalPending,
  selectWeightMeasurementEntityModalPending,
  selectHeightMeasurementEntityModalPending,
  selectSaturationMeasurementEntityModalPending,
  selectHeartRateMeasurementEntityModalPending,
  (
    stepsDataPending,
    distanceDataPending,
    bmiDataPending,
    weightDataPending,
    heightDataPending,
    saturationDataPending,
    heartRateDataPending,
    bloodGlucoseDataPending,
  ) =>
    stepsDataPending ||
    distanceDataPending ||
    bmiDataPending ||
    weightDataPending ||
    heightDataPending ||
    saturationDataPending ||
    heartRateDataPending ||
    bloodGlucoseDataPending,
);



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/selectors.js